import React, { useRef, useContext } from "react";
import { BGLoadedContext } from "../contexts/BGLoadedProvider";
import { graphql, useStaticQuery } from "gatsby";

type DataProps = {
  allContentfulHomePage: {
    edges: [
      {
        node: {
          background: {
            file: {
              url: string;
            };
          };
          siteTitle: string;
          icon: {
            file: {
              url: string;
            };
          };
        };
      }
    ];
  };
};

const BackgroundVideo = () => {
  const { isBGLoaded, setIsBGLoaded } = useContext(BGLoadedContext);
  const wrapper = useRef<HTMLDivElement>(null);
  const query: DataProps = useStaticQuery(graphql`
    query {
      allContentfulHomePage {
        edges {
          node {
            background {
              file {
                url
              }
            }
          }
        }
      }
    }
  `);

  const fadeInWrapper = () => {
    if (wrapper.current && !isBGLoaded) {
      wrapper.current.classList.add("loaded");
      setIsBGLoaded(true);
    }
  };

  // useEffect(() => {
  //   if (!isBGLoaded) return;
  //   const t = setTimeout(() => {
  //     if (wrapper.current) wrapper.current.classList.add("loaded");
  //   }, 500);
  //   return () => {
  //     clearTimeout(t);
  //   };
  // }, [isBGLoaded]);

  return (
    <div id="background-wrapper" ref={wrapper}>
      <video
        autoPlay={true}
        muted
        playsInline
        disablePictureInPicture
        loop
        id="background-video"
        onCanPlay={fadeInWrapper}
        preload="auto"
      >
        <source
          src={query.allContentfulHomePage.edges[0].node.background.file.url}
          type="video/mp4"
        />
      </video>
    </div>
  );
};

export default BackgroundVideo;
